import { z } from "zod";

const NumberOfRoomBookedDataResponse = z.object({
    date: z.string(),
    total_booked_rooms: z.coerce.number().int().nonnegative(),
});

const NumberOfRoomBookedResponseSchema = z.object({
    success: z.boolean(),
    message: z.string().min(1, "Message cannot be empty"),
    code: z.number().int().nonnegative("Code must be a non-negative integer"),
    data: z.array(NumberOfRoomBookedDataResponse),
});

export type NumberOfRoomBookedDataResponse = z.infer<typeof NumberOfRoomBookedDataResponse>;
export type NumberOfRoomBookedResponse = z.infer<typeof NumberOfRoomBookedResponseSchema>;
export { NumberOfRoomBookedDataResponse, NumberOfRoomBookedResponseSchema };